export default __webpack_public_path__ + "static/media/black-thinkport-horizontal.d387d8ef.png";